import type { TwoLineMapResult } from '../../react/views/adminTwoLineMap'

// Draws two lines on one map (D20). The element carries `data-key` and
// `data-params` (JSON). On mount the hook pushes `load_two_line_map` with
// both, and the LiveView answers with a `two_line_map:lines` event carrying
// the same key and either `lines` ([{label, geometry}]) or `error`. Inside a
// LiveComponent, the event goes to that component.
export const AdminTwoLineMapHook: {
  el?: HTMLElement
  pushEventTo?: (target: HTMLElement, event: string, payload: object) => void
  handleEvent?: (event: string, callback: (payload: TwoLineMapResult) => void) => void
  mounted: () => void
  destroyed: () => void
  unMountComponent?: (() => void) | undefined
  isDestroyed?: boolean
} = {
  mounted() {
    if (!this.el || !this.pushEventTo || !this.handleEvent) {
      return
    }

    const rootElement = this.el
    const key = rootElement.dataset.key ?? ''
    const handleEvent = this.handleEvent.bind(this)

    let params = {}
    try {
      params = JSON.parse(rootElement.dataset.params ?? '{}')
    } catch (error) {
      console.error('[AdminTwoLineMapHook] Failed to parse params:', error)
    }

    const result = new Promise<TwoLineMapResult>(function waitForLines(resolve) {
      handleEvent('two_line_map:lines', function handleLines(payload) {
        if (payload.key === key) {
          resolve(payload)
        }
      })
    })

    this.pushEventTo(rootElement, 'load_two_line_map', { key, params })

    void import('../../react/views/AdminTwoLineMapView')
      .then(({ AdminTwoLineMapView }) => {
        if (this.isDestroyed) {
          return
        }

        this.unMountComponent = AdminTwoLineMapView({ rootElement, result })
      })
      .catch((error) => {
        console.error('[AdminTwoLineMapHook] Failed to load map view:', error)
      })
  },
  destroyed() {
    this.isDestroyed = true
    this.unMountComponent?.()
  },
}
